<template>
  <Container type="card-full">
    <div slot="header"></div>
    <!-- <div class="fwlxbox">
      <div class="fwlx">采购类型</div>
      <div class="fwlxselect">
        <el-select v-model="cg.pmchargefeetype" placeholder="请选择" :disabled="pmform" @change = "search">
          <el-option
            v-for="(item, index) in chargefeetypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </div>
    </div> -->
    <div class="container">
      <div>
        <vgtree
          ref="xTree"
          class="vgtree"
          :list="list"
          tableheight="700"
          flexname=""
          :cols="cols"
          :showfooter="false"
          :showPage="false"
          :resizable="true"
          @cellClick="cellClick"
        >
          <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
          </template>
        </vgtree>
      </div>
      <el-form :model="form" ref="ruleForm" class="content ss-fl" v-if="pmform">
        <!-- <el-form-item label="序号" :label-width="formLabelWidth" >
          <el-input v-model="form.pmseq" :maxlength="6"  show-word-limit auto-complete="off" :disabled="true"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="上级" :label-width="formLabelWidth" verify>
          {{parent.pmcode}}-{{parent.pmname}}
        </el-form-item> -->

        <el-form-item
          label="上级"
          :label-width="formLabelWidth"
          prop="pmparentid"
          verify
        >
          <el-select v-model="form.pmparentid" :clearable="true">
            <el-option
              v-for="(item, index) in pmappendList"
              :label="item.pmname"
              :value="item.pmid"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="代号"
          :label-width="formLabelWidth"
          prop="pmcode"
          :verify="validateCodeInfo"
        >
          <el-input
            v-model="form.pmcode"
            :maxlength="40"
            show-word-limit
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          :label-width="formLabelWidth"
          prop="pmname"
          verify
        >
          <el-input
            v-model="form.pmname"
            :maxlength="128"
            show-word-limit
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="服务费类型"
          :label-width="formLabelWidth"
          prop="pmchargefeetype"
          verify
        >
          <el-select v-model="form.pmchargefeetype" :clearable="true">
            <el-option
              v-for="(item, index) in chargefeetypeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="savePm">保存</el-button>
          <el-button type="primary" @click="shutdownPm">关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import vgtree from "../common/vgtree1";
import MenuBtn from "../common/menuBtn";
import common from "@/mixin/common";
const SUCCESS = 1;
export default {
  name: "pmIndex",
  mixins: [common],
  data() {
    return {
      menuid: this.$route.query.menuid,
      list: [],
      btnLoading: false,
      pmform: false,
      pmList: [],
      pmappendList: [],
      pmShowTypeList: [],
      chargefeetypeList: [],
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 80,
        },
        { field: "pmname", fieldtype: "C", title: "名称", calculExpr: "" },
      ],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        cositemcomtype: this.$store.getters.loginUser.cositemcomtype,
        // projecttype: '1',
        total: 0,
        limit: 20,
        offset: 0,
        currPage: 1,
        pageSize: 20,
      },
      parent: {
        pmcode: "",
        pmname: "",
        pmid: 0,
      },
      pjlist: [],
      pm: {}, // 采购品目
      cg: {}, // 采购类型
      form: {},
      loading: true,
      formLabelWidth: "100px",
    };
  },
  activated() {
    this.getPmTree();
    this.getPmList();
    this.getProjectpm();
  },
  created() {
    this.$on("ADD", () => this.addPm());
    this.$on("INS", () => this.insPm());
    this.$on("CHG", () => this.chgPm());
    this.$on("DEL", () => this.delPm());
    this.$on("CLOSE", () => this.close());
    this.getPmList();
  },
  mounted() {
    this.getchargefeetypeList();
  },
  watch: {
    $route() {},
  },
  components: { MenuBtn, vgtree },
  methods: {
    validateCodeInfo(rul, val, callback) {
      this.validateData(
        "代号不能重复",
        "pmrec",
        "pmid",
        "pmcode",
        val,
        "pmcosid",
        callback
      );
    },
    validateData(
      msg,
      tablename,
      fieldid,
      checkfield,
      checkval,
      fieldkey1,
      callback
    ) {
      request({
        url: "/validate/validateData",
        method: "post",
        data: {
          tablename,
          fieldid,
          checkfield,
          checkval: this.form[checkfield],
          fieldkey1,
          fieldkeyval1: this.$store.getters.loginUser.cosid,
          id: this.form.pmid,
        },
      }).then((res) => {
        res === SUCCESS ? callback(Error(msg)) : callback();
      });
    },
    initform() {
      this.pm = {};
      this.form = {};
    },
    btnClick(code) {
      this.$emit(code);
    },
    async addPm() {
      // if(!this.cg.pmchargefeetype){
      //   this.$message.warning('请先选择服务类型!')
      //   return
      // }
      this.initform();
      let maxSeq = 0;
      this.list.forEach((item) => {
        if (item.pmseq > maxSeq) {
          maxSeq = item.pmseq;
        }
      });
      maxSeq += 10;
      this.form = {
        pmid: 0,
        pmparentid: this.parent.pmid || "",
        pmcosid: this.$store.getters.loginUser.cosid,
        pmchargefeetype: this.parent.pmchargefeetype || "",
        pmseq: maxSeq,
        pmcode: "",
        pmname: "",
      };
      this.pmform = true;
      this.getPmList();
    },
    async insPm() {
      this.initform();
      let maxSeq = 0;
      this.list.forEach((item) => {
        if (item.pmseq > maxSeq) {
          maxSeq = item.pmseq;
        }
      });
      maxSeq += 10;
      this.form = {
        pmid: 0,
        pmparentid: this.parent.pmid,
        pmcosid: this.$store.getters.loginUser.cosid,
        pmseq: maxSeq,
        pmcode: "",
        pmname: "",
      };
      this.pmform = true;
    },
    async delPm() {
      let idx = this.pjlist.findIndex((e) => {
        return Number(e.projectpmid) === this.parent.pmid;
      });

      if (idx >= 0) {
        this.$message.warning("项目存在该品目，不可以删除");
        return;
      }
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        if (this.parent.children) {
          this.$message.warning("该品目存在子项，不可以删除");
          return;
        }

        let data = await request({
          url: "/basic/pm/delPm",
          method: "post",
          data: this.form,
        });
        if (data.issuccess === 1) {
          this.getPmTree();
          this.$message.success("删除成功！");
        }
      });
    },
    async getProjectpm() {
      let res;
      res = await request({
        method: "get",
        url: "/xmgl/project/getProject_haspm",
        params: this.query,
      });
      this.pjlist = res;
    },
    async savePm() {
      this.submitForm("ruleForm")
        .then(async () => {
          await request({
            url: "/basic/pm/savePm",
            method: "post",
            data: this.form,
          });
          this.$message.success("操作成功");
          await this.getPmTree();
          this.pmform = false;
        })
        .catch(() => {});
      this.getPmList();
    },
    async cellClick(row) {
      this.initform();
      this.pm = row.row;
      this.form = row.row;
      this.parent = row.row;
      this.pmform = true;
      this.getchargefeetypeList();
    },
    async getPmTree() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/basic/pm/getPmTree",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.list = res.list;
      this.loading = false;
    },
    async getPmList() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/basic/pm/getPmList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.pmappendList = res;
      this.pmappendList.unshift({
        pmname: "无",
        pmid: 0,
        pmchargefeetype: this.cg.pmchargefeetype,
      });
      this.loading = false;
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "pmIndex",
      });
    },
    async getchargefeetypeList() {
      this.chargefeetypeList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "chargefeetype" },
      });
    },
    search() {
      this.getPmTree();
    },
    shutdownPm() {
      this.pmform = false;
    },
  },
  filters: {},
};
</script>

<style lang="scss" scoped>
.fwlxbox {
  display: flex;
  line-height: 55px;
  margin-bottom: 20px;
  .fwlx {
    margin-right: 20px;
  }
  .fwlxselect {
  }
}
.container {
  display: flex;
  .vgtree {
    border: 1px solid #d1dbe5;
    width: 400px;
    margin-right: 5px;
  }
  .vggrid {
    margin-left: 50px;
    width: 800px;
  }
  .content {
    width: 100%;
    padding-top: 10px;
    padding-right: 10px;
    border: 1px solid #d1dbe5;
  }
}
</style>
